import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import About from '~/components/About';
import Contact from '~/components/Contact';
import RemoteImage from '~/components/RemoteImage';
import Tickets from '~/components/tickets';
import Volunteer from '~/components/Volunteer';

import { langStore } from '~/store/langStore';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  const locale = useStore(langStore, s => s);
  return (
    <div className="bg-[#231F20]">

      <RemoteImage src="/landing_pic.webp" alt="Homescreen" className="mx-auto w-full" />

      {/* <p className="
      text-3xl
      text-orange
      text-center
      mt-1 md:mt-6
      mb-1 md:mb-10
      bg-blackish font-semibold font-eurostile bg-blackpng"
      >
        SUPPORT COMMUNITY, ART AND ENVIRONMENT
      </p> */}

      <div className="relative bg-black p-8">
        {/* Ferde háttér */}
        <div
          className="absolute inset-0
          origin-top-left -skew-y-1 transform
          border-8 border-orange bg-paper
          bg-cover bg-center"
        >
        </div>

        {/* Tartalom */}
        <div className="relative p-12 text-center">

          <RemoteImage
            src={`/jegy-${locale.toLowerCase()}.png`}
            alt="jegyed van már?"
            className="
            mx-auto
            mb-10
            "
          />
          <Tickets />

        </div>
      </div>
      {/* <Artists /> */}
      <hr className="h-1 bg-white" />
      <About />
      <hr className="h-1 bg-white" />
      <Volunteer />
      <div className="bg-blackpng bg-cover bg-no-repeat">
        <Contact className="md:flex-row" />
      </div>
    </div>
  );
}
